module.exports = __webpack_public_path__ + "static/media/tag.7c7c74f4.svg";